var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-text"},[_c('img',{attrs:{"src":_vm.content.img.filename,"alt":""}}),_c('vue-markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.content.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }